import { render, staticRenderFns } from "./searchInput.vue?vue&type=template&id=10d0dcae&scoped=true&"
import script from "./searchInput.vue?vue&type=script&lang=js&"
export * from "./searchInput.vue?vue&type=script&lang=js&"
import style0 from "./searchInput.vue?vue&type=style&index=0&id=10d0dcae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0dcae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
